import React,{Suspense,lazy} from 'react'
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import {Provider} from 'react-redux'
import { toast } from 'react-toastify';
import store from './store/store';
import 'react-toastify/dist/ReactToastify.css';
import Loader from './components/loader';
import ErrorBoundaryMain from './errorBoundaryMain';

const SelectBuilding = lazy(() => import('./layout/selectBuilding'));

const  Dashboard =  lazy(() => import('./layout/dashboard'));

const  ForgotPassword = lazy(() => import('./layout/forgetPassword'))  ;

const Login = lazy(() => import('./layout/login'));

// Call it once in your app. At the root of your app is the best place
toast.configure()

function App() {
  const login = localStorage.getItem('token');
  const loginStatus = Boolean(login);
  if(loginStatus)
   return(
     <Provider store={store}>
       <BrowserRouter>
         <ErrorBoundaryMain>
           <Suspense fallback={(
             <Loader
               style={{
                 position:'absolute',
                 height:'100px',
                 width:'100px',
                 top:'45%',
                 left:'45%'}}
             />
)}
           >
             <Switch>
               <Route exact path="/select" render={props => <SelectBuilding {...props} />} />
               <Route path="/" render={props => <Dashboard {...props} />} />
             </Switch>
           </Suspense>
         </ErrorBoundaryMain>
       </BrowserRouter>
     </Provider>
   )
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Suspense fallback={(
          <Loader
            style={{
          position:'absolute',
          height:'100px',
          width:'100px',
          top:'45%',
          left:'45%'
        }}
          />
)}
        >
          <Switch>
            <Route exact path="/resetpassword" render={props => <ForgotPassword {...props} />} />
            <Route exact path="/" render={props => <Login {...props} />} />
            <Redirect from="*" to="/" />
          </Switch>
        </Suspense>
      </BrowserRouter>
    </Provider>
  )
}

App.propTypes = {

}

export default App

